module.exports = __webpack_public_path__ + "/public/images/4944b298c837d734950e2d504eb47cb0.svg";